import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const SuccessText = styled(Typography)({
  fontSize: '16px',
  lineHeight: '24px',
  color: '#353F48',
  maxWidth: '400px'
})
